import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import bg from "../../assets/welcomeImage.jpeg";
import bgRepeat from "../../assets/bg_repeat.png";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import TuneIcon from "@mui/icons-material/Tune";
import BoltIcon from "@mui/icons-material/Bolt";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ResponsiveFeaturesBar from "./ResponsiveFeaturesBar";
import { Box } from "@mui/material";

const theme = {
  primary: "#c84653",
  secondary: "#444349",
  white: "#fff",
  fontMain: '"Poppins", sans-serif',
  fontTitle: '"Sansita One", cursive',
};

const Prices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        fontFamily: theme.fontMain,
        color: theme.secondary,
        background: `linear-gradient(120deg, #f7f5f2 0%, #fff 100%)`,
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      {/* Header - restored with image background, consistent with contact page */}
      <div
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          padding: "100px 20px",
          position: "relative",
        }}
      >
        <h1
          style={{
            fontFamily: theme.fontTitle,
            fontSize: "clamp(2.5rem, 6vw, 4rem)",
            color: "white",
            textShadow: "2px 2px 8px rgba(0,0,0,0.7)",
            margin: 0,
          }}
        >
          Tarifs du Tourbus
        </h1>
        <p
          style={{
            fontSize: "clamp(1rem, 2vw, 1.2rem)",
            maxWidth: 600,
            margin: "0 auto",
            opacity: 0.95,
            fontWeight: 500,
            color: "#fff",
            marginTop: 16,
          }}
        >
          Découvrez nos offres comme sur la carte d'un restaurant !
        </p>
      </div>

      {/* Intro Section to fill space */}
      <div
        style={{
          maxWidth: 900,
          margin: "48px auto 0 auto",
          padding: "0 20px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 18,
            marginBottom: 18,
          }}
        >
          <h2
            style={{
              fontFamily: theme.fontTitle,
              color: theme.primary,
              fontSize: 28,
              margin: 0,
            }}
          >
            Un tourbus, mille possibilités
          </h2>
        </div>
        <p
          style={{
            fontSize: 18,
            color: theme.secondary,
            opacity: 0.85,
            marginBottom: 0,
          }}
        >
          Profitez d'un véhicule unique pour vos soirées, tournées, événements
          et bien plus encore. Nos offres sont flexibles et adaptées à chaque
          projet.
        </p>
      </div>
      <div>
        <ResponsiveFeaturesBar />
      </div>
      <div
        style={{
          maxWidth: "1800px",
          margin: "64px auto 0 auto",
          padding: "0 32px",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 48,
            flexWrap: "wrap",
            justifyContent: "center",
            marginBottom: 64,
          }}
        >
          {/* Soirées Privées Card */}
          <div
            style={{
              flex: "1 1 340px",
              maxWidth: 400,
              background: theme.white,
              borderRadius: 32,
              boxShadow: "0 16px 48px rgba(200,70,83,0.12)",
              padding: "48px 32px 36px 32px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              minWidth: 280,
              transition: "box-shadow 0.3s",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -32,
                left: 32,
                background: theme.primary,
                color: theme.white,
                fontFamily: theme.fontTitle,
                fontSize: 20,
                padding: "10px 24px",
                borderRadius: 16,
                boxShadow: "0 2px 12px rgba(200,70,83,0.15)",
                letterSpacing: 1,
              }}
            >
              Soirées Privées (Paris)
            </div>

            <div
              style={{
                fontSize: 19,
                color: theme.secondary,
                textAlign: "center",
                fontWeight: 600,
                marginBottom: 8,
              }}
            >
              Soirées Privées
            </div>
            <div
              style={{
                fontSize: 16,
                color: theme.secondary,
                textAlign: "center",
                marginBottom: 8,
              }}
            >
              Salle de fête roulante à Paris, idéale pour anniversaires,
              EVJF/EVG, team building...
            </div>
            <ul
              style={{
                fontSize: 15,
                color: theme.secondary,
                textAlign: "left",
                margin: "0 auto 8px auto",
                maxWidth: 260,
                paddingLeft: 18,
              }}
            >
              <li>Chauffeur inclus</li>
              <li>Options : sono, lumière, écran, animateur</li>
            </ul>
            <div
              style={{
                borderTop: "1px solid #eee",
                marginBottom: "8px",
                width: "100%",
                marginTop: "auto",
              }}
            ></div>

            <div style={{ fontSize: 18, textAlign: "center", marginBottom: 2 }}>
              3h :{" "}
              <span
                style={{
                  color: theme.primary,
                  fontWeight: 700,
                  fontSize: 20,
                }}
              >
                700 €
              </span>{" "}
              &nbsp;|&nbsp; 4h :{" "}
              <span
                style={{
                  color: theme.primary,
                  fontWeight: 700,
                  fontSize: 20,
                }}
              >
                900 €
              </span>
            </div>
            <div
              style={{
                fontSize: 15,
                color: theme.secondary,
                textAlign: "center",
              }}
            >
              Autres durées/options : <b>Sur devis</b>
            </div>
          </div>

          {/* Voyages & Tournées Card */}
          <div
            style={{
              flex: "1 1 340px",
              maxWidth: 400,
              background: theme.white,
              borderRadius: 32,
              boxShadow: "0 16px 48px rgba(200,70,83,0.12)",
              padding: "48px 32px 36px 32px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              minWidth: 280,
              transition: "box-shadow 0.3s",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -32,
                left: 32,
                background: theme.primary,
                color: theme.white,
                fontFamily: theme.fontTitle,
                fontSize: 20,
                padding: "10px 24px",
                borderRadius: 16,
                boxShadow: "0 2px 12px rgba(200,70,83,0.15)",
                letterSpacing: 1,
              }}
            >
              Voyages & Tournées (&gt;24h)
            </div>

            <div
              style={{
                fontSize: 19,
                color: theme.secondary,
                textAlign: "center",
                fontWeight: 600,
                marginBottom: 8,
              }}
            >
              Voyages & Tournées
            </div>
            <div
              style={{
                fontSize: 16,
                color: theme.secondary,
                textAlign: "center",
                marginBottom: 8,
              }}
            >
              Base mobile avec couchages pour festivals, week-ends,
              mini-tournées, hébergements insolites.
            </div>
            <ul
              style={{
                fontSize: 15,
                color: theme.secondary,
                textAlign: "left",
                margin: "0 auto 8px auto",
                maxWidth: 260,
                paddingLeft: 18,
              }}
            >
              <li>Chauffeur professionnel inclus</li>
              <li>Départ Paris (autres villes sur demande)</li>
            </ul>
            <div
              style={{
                borderTop: "1px solid #eee",
                marginBottom: "8px",
                width: "100%",
                marginTop: "auto",
              }}
            ></div>

            <div
              style={{
                fontSize: 18,
                color: theme.primary,
                fontWeight: 700,
                textAlign: "center",
                marginBottom: 2,
              }}
            >
              Sur devis
            </div>
            <div
              style={{
                fontSize: 15,
                color: theme.secondary,
                textAlign: "center",
              }}
            >
              Selon distance, durée et options
            </div>
          </div>

          {/* Tournages & Loges Mobiles Card */}
          <div
            style={{
              flex: "1 1 340px",
              maxWidth: 400,
              background: theme.white,
              borderRadius: 32,
              boxShadow: "0 16px 48px rgba(200,70,83,0.12)",
              padding: "48px 32px 36px 32px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              minWidth: 280,
              transition: "box-shadow 0.3s",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -32,
                left: 32,
                background: theme.primary,
                color: theme.white,
                fontFamily: theme.fontTitle,
                fontSize: 20,
                padding: "10px 24px",
                borderRadius: 16,
                boxShadow: "0 2px 12px rgba(200,70,83,0.15)",
                letterSpacing: 1,
              }}
            >
              Tournages & Loges Mobiles
            </div>

            <div
              style={{
                fontSize: 19,
                color: theme.secondary,
                textAlign: "center",
                fontWeight: 600,
                marginBottom: 8,
              }}
            >
              Tournages & Loges Mobiles
            </div>
            <div
              style={{
                fontSize: 16,
                color: theme.secondary,
                textAlign: "center",
                marginBottom: 8,
              }}
            >
              Espace mobile pro pour tournages, shootings, loges, showroom
              itinérant.
            </div>
            <ul
              style={{
                fontSize: 15,
                color: theme.secondary,
                textAlign: "left",
                margin: "0 auto 8px auto",
                maxWidth: 260,
                paddingLeft: 18,
              }}
            >
              <li>Salon modulable, sanitaires</li>
              <li>Prestations : clip, shooting, loge, showroom</li>
            </ul>
            <div
              style={{
                borderTop: "1px solid #eee",
                marginBottom: "8px",
                width: "100%",
                marginTop: "auto",
              }}
            ></div>

            <div
              style={{
                fontSize: 18,
                color: theme.primary,
                fontWeight: 700,
                textAlign: "center",
                marginBottom: 2,
              }}
            >
              Sur devis
            </div>
            <div
              style={{
                fontSize: 15,
                color: theme.secondary,
                textAlign: "center",
              }}
            >
              Selon durée, lieu et usage
            </div>
          </div>
        </div>

        {/* Row 2: 1 card centered */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 64,
          }}
        >
          <div
            style={{
              flex: "1 1 600px",
              maxWidth: 700,
              background: theme.white,
              borderRadius: 32,
              boxShadow: "0 16px 48px rgba(200,70,83,0.12)",
              padding: "64px 56px 48px 56px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              minWidth: 340,
              transition: "box-shadow 0.3s",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -32,
                left: 40,
                background: theme.primary,
                color: theme.white,
                fontFamily: theme.fontTitle,
                fontSize: 22,
                padding: "10px 28px",
                borderRadius: 16,
                boxShadow: "0 2px 12px rgba(200,70,83,0.15)",
                letterSpacing: 1,
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              {/* MUI Icon instead of SVG */}
              <EventAvailableIcon
                style={{ color: theme.white, fontSize: 28, opacity: 0.9 }}
              />
              Autres demandes
            </div>
            <div style={{ width: "100%", textAlign: "center" }}>
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 600,
                  marginBottom: 18,
                  color: theme.secondary,
                  fontFamily: theme.fontTitle,
                  marginTop: 24,
                }}
              >
                Parlons-en !
              </div>
              <div
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  marginBottom: 18,
                  color: theme.secondary,
                }}
              >
                Nos équipes sont à votre écoute pour vous proposer la meilleure
                des solutions en fonction de votre projet !
              </div>
              <Link
                to="/contact"
                style={{
                  backgroundColor: theme.primary,
                  border: "none",
                  color: theme.white,
                  fontWeight: 700,
                  fontFamily: theme.fontTitle,
                  fontSize: 16,
                  padding: "14px 24px",
                  borderRadius: 12,
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                  textDecoration: "none",
                  marginTop: 18,
                  transition: "all 0.3s ease",
                }}
              >
                <EventAvailableIcon style={{ color: "white", fontSize: 20 }} />
                Demander un devis
              </Link>
            </div>
          </div>
        </div>

        {/* Divider - repeating SVG image, always full width */}
        <div
          style={{
            position: "relative",
            left: "50%",
            right: "50%",
            width: "100vw",
            height: 120,
            backgroundImage: `url(${bgRepeat})`,
            backgroundRepeat: "repeat-x",
            backgroundSize: "contain",
            margin: "0 -50vw 48px -50vw",
            zIndex: 2,
          }}
        />

        {/* Contact & FAQ Card Section */}
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto 4em auto",
            padding: "3em 2em",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 18,
              boxShadow: "0 4px 16px rgba(200,70,83,0.07)",
              display: "flex",
              flexDirection: "row",
              gap: 32,
              alignItems: "stretch",
              flexWrap: "wrap",
            }}
          >
            {/* FAQ Side */}
            <div
              style={{
                flex: 1,
                minWidth: 280,
                padding: 24,
                borderRight: "1px solid #f3eaea",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <h3
                style={{
                  color: theme.primary,
                  fontFamily: theme.fontTitle,
                  fontSize: 24,
                  marginBottom: 12,
                }}
              >
                Questions fréquentes
              </h3>
              <div
                style={{
                  color: theme.secondary,
                  fontSize: 17,
                  marginBottom: 18,
                  paddingLeft: 0,
                }}
              >
                <div style={{ marginBottom: 18 }}>
                  <strong style={{ color: theme.primary }}>
                    Combien de personnes peut accueillir le bus ?
                  </strong>
                  <div style={{ marginTop: 4 }}>
                    Jusqu'à 18 personnes maximum.
                  </div>
                </div>
                <div style={{ marginBottom: 18 }}>
                  <strong style={{ color: theme.primary }}>
                    Peut-on louer le bus pour une soirée privée, un
                    anniversaire, un EVJF/EVG, un concert, un mariage, etc. ?
                  </strong>
                  <div style={{ marginTop: 4 }}>
                    Oui, c'est exactement sa vocation : un lieu mobile, festif
                    et unique pour tous vos événements.
                  </div>
                </div>
                <div style={{ marginBottom: 0 }}>
                  <strong style={{ color: theme.primary }}>
                    Le bus est-il adapté à des événements d'entreprise (team
                    building, afterwork, etc.) ?
                  </strong>
                  <div style={{ marginTop: 4 }}>
                    Oui, il convient parfaitement pour des événements
                    professionnels.
                  </div>
                </div>
              </div>
              <a
                href="/faq"
                style={{
                  color: theme.primary,
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: 16,
                }}
              >
                Voir toutes les questions
              </a>
            </div>

            {/* Contact Form Side (cloned from Contact.js) */}
            <div
              style={{
                flex: 1.2,
                minWidth: 320,
                padding: 24,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <h3
                style={{
                  color: theme.primary,
                  fontFamily: theme.fontTitle,
                  fontSize: 24,
                  marginBottom: 12,
                }}
              >
                Contactez-nous
              </h3>
              <form
                style={{
                  marginTop: 10,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 18,
                  maxWidth: 500,
                  marginInline: "auto",
                  padding: "0.5rem",
                }}
              >
                <input
                  type="text"
                  placeholder="Nom"
                  style={{
                    backgroundColor: "#faf7f5",
                    padding: "16px 20px",
                    fontSize: 16,
                    borderRadius: 8,
                    border: "1px solid #ddd",
                    width: "100%",
                    boxSizing: "border-box",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                    outline: "none",
                  }}
                />
                <input
                  type="text"
                  placeholder="Prénom"
                  style={{
                    backgroundColor: "#faf7f5",
                    padding: "16px 20px",
                    fontSize: 16,
                    borderRadius: 8,
                    border: "1px solid #ddd",
                    width: "100%",
                    boxSizing: "border-box",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                    outline: "none",
                  }}
                />
                <input
                  type="email"
                  placeholder="Adresse Email *"
                  style={{
                    backgroundColor: "#faf7f5",
                    padding: "16px 20px",
                    fontSize: 16,
                    borderRadius: 8,
                    border: "1px solid #ddd",
                    width: "100%",
                    boxSizing: "border-box",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                    outline: "none",
                  }}
                />
                <input
                  type="text"
                  placeholder="Sujet *"
                  style={{
                    backgroundColor: "#faf7f5",
                    padding: "16px 20px",
                    fontSize: 16,
                    borderRadius: 8,
                    border: "1px solid #ddd",
                    width: "100%",
                    boxSizing: "border-box",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                    outline: "none",
                  }}
                />
                {/* You can add your CustomPhoneInput here if needed */}
                <textarea
                  placeholder="Votre message *"
                  rows="5"
                  style={{
                    backgroundColor: "#faf7f5",
                    padding: "16px 20px",
                    fontSize: 16,
                    borderRadius: 8,
                    border: "1px solid #ddd",
                    width: "100%",
                    boxSizing: "border-box",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    minHeight: "120px",
                    resize: "vertical",
                    gridColumn: "1 / -1",
                  }}
                ></textarea>
                <div
                  style={{
                    gridColumn: "1 / -1",
                    textAlign: "center",
                    marginTop: "10px",
                  }}
                >
                  <button
                    type="submit"
                    style={{
                      backgroundColor: theme.primary,
                      color: "white",
                      fontWeight: 600,
                      fontSize: 16,
                      borderRadius: 8,
                      border: "none",
                      padding: "14px 36px",
                      cursor: "pointer",
                      boxShadow: "0 4px 6px rgba(200, 70, 83, 0.2)",
                      position: "relative",
                    }}
                  >
                    Envoyer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ...existing code... */}
      </div>
    </div>
  );
};

export default Prices;
